export const Logo = () => {
    return (
        <div>
            <img src="assets/images/logo-anserini.svg" alt="logo" />
        </div>
    );
};
